import { render, staticRenderFns } from "./content-component.vue?vue&type=template&id=63da58dc&scoped=true"
import script from "./content-component.vue?vue&type=script&lang=js"
export * from "./content-component.vue?vue&type=script&lang=js"
import style0 from "./content-component.vue?vue&type=style&index=0&id=63da58dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da58dc",
  null
  
)

export default component.exports